module.exports = __webpack_public_path__ + "media/packs/user-cards/images/star-b9a8533ed50633610231760a036c1041.svg";